import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = { class: "grid md:grid-cols-2 lg:grid-cols-3 gap-6" }
const _hoisted_5 = { class: "flex items-center mb-4" }
const _hoisted_6 = { class: "font-semibold text-gray-800" }
const _hoisted_7 = { class: "text-sm text-gray-600" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "flex justify-between items-center mb-1" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_11 = { class: "text-sm text-gray-500" }
const _hoisted_12 = { class: "w-full bg-gray-200 rounded-full h-2" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "text-xs text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('skills.title')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skill) => {
        return (_openBlock(), _createElementBlock("div", {
          key: skill.name,
          class: "bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "w-12 h-12 rounded-lg flex items-center justify-center text-2xl mr-4",
              style: _normalizeStyle({ backgroundColor: skill.color + '20' })
            }, _toDisplayString(skill.icon), 5),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(skill.name), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(skill.level), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('skills.proficiency')), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(skill.percentage) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "h-2 rounded-full transition-all duration-700 ease-out",
                style: _normalizeStyle({ 
                width: skill.percentage + '%',
                background: `linear-gradient(90deg, ${skill.color}, ${skill.color}99)`
              })
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(skill.description), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}